import {ProjectStatus, ProjectTab} from "../interfaces";

interface requiredConfigElement {
    field: string;
    name: string;
    tab: ProjectTab;
    required: ProjectStatus[],
}

export const requiredConfig: requiredConfigElement[] = [
    {
        field: 'title_project',
        name: 'Projekttitel',
        tab: ProjectTab.GOALS,
        required: [ProjectStatus.IN_ELABORATION]
    },
    {
        field: 'strategic_classification',
        name: 'Strategische Zuordnung',
        tab: ProjectTab.GOALS,
        required: [ProjectStatus.IN_ELABORATION]
    },
    {
        field: 'goals',
        name: 'Ziele',
        tab: ProjectTab.GOALS,
        required: [ProjectStatus.IN_ELABORATION]
    },
    {
        field: 'dates_start_planned',
        name: 'Projektstart PLAN',
        tab: ProjectTab.DATES,
        required: [ProjectStatus.IN_ELABORATION]
    },
    {
        field: 'dates_end_planned',
        name: 'Projektende PLAN',
        tab: ProjectTab.DATES,
        required: [ProjectStatus.IN_ELABORATION]
    },
    {
        field: 'milestones',
        name: 'Meilensteine',
        tab: ProjectTab.DATES,
        required: [ProjectStatus.IN_ELABORATION]
    },
    {
        field: 'teams_created',
        name: 'Anlage Teams',
        tab: ProjectTab.EXTERNAL,
        required: [ProjectStatus.RELEASED]
    },
    {
        field: 'dynamics_created',
        name: 'Anlage Projektmodul D365',
        tab: ProjectTab.EXTERNAL,
        required: [ProjectStatus.RELEASED]
    },
    {
        field: 'cost_centre',
        name: 'Kostenstelle',
        tab: ProjectTab.EXTERNAL,
        required: [ProjectStatus.RELEASED]
    },
    {
        field: 'cost_type',
        name: 'Projektart',
        tab: ProjectTab.EXTERNAL,
        required: [ProjectStatus.RELEASED]
    },
];
